<template>
  <v-container fill-height>
    <v-layout justify-center>
      <v-flex>
        <div class="breadcrumbs__wrapper">
          <span class="breadcrumbs__title">
            {{
              typeSelection === 1 ? "Empresas Proveedoras" : "Empresas Clientes"
            }}
          </span>
          <!-- <v-menu bottom origin="center center" transition="scale-transition">
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="white--text" v-bind="attrs" v-on="on"
                ><v-icon left> mdi-plus</v-icon> AÑADIR</v-btn
              >
            </template>
            <v-list>
              <v-list-item
                :key="getRoute.title"
                :to="getRoute.to"
                class="menu__dropdown"
              >
                <v-list-item-title>{{ getRoute.title }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu> -->
        </div>
        <v-divider class="mt-2"></v-divider>
        <!-- <v-row class="mt-10">
          <v-col class="button__wrapper" cols="10">
            <v-btn
              :class="
                typeSelection === 1
                  ? 'white--text'
                  : 'white--text btn__not__selected'
              "
              @click="typeSelection = 1"
              ><v-icon left> mdi-card-account-details-outline</v-icon>
              PROVEEDORES</v-btn
            ><v-btn
              :class="
                typeSelection === 2
                  ? 'white--text ml-4'
                  : 'white--text ml-4 btn__not__selected'
              "
              @click="typeSelection = 2"
              ><v-icon left> mdi-account-tie</v-icon> Clientes</v-btn
            >
          </v-col>
        </v-row> -->
        <!-- table Proveedores -->
        <SupplierTable
          v-if="typeSelection === 1"
          class="mt-10"
          :headers="this.headersSuppliers"
          :values="buildTypeOfClient('suppliers')"
        />
        <Table
          v-else
          class="mt-10"
          :headers="this.headersClients"
          path="ceclient"
          collection="suppliers"
          :values="buildTypeOfClient('clients')"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Table from "@/components/Table.vue";
import SupplierTable from "@/components/suppliers/SupplierTable.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "Suppliers",
  props: ["types"],
  components: {
    Table,
    SupplierTable,
  },
  data() {
    return {
      search: "",
      /**
       * 1 - Proveedores
       * 2 - Clients
       */
      typeSelection: 1,
      items: [
        { title: "Proveedor", to: "/cesupplier" },
        { title: "Cliente", to: "/ceclient" },
      ],
      headersClients: [
        {
          text: "Denominación jurídica",
          align: "start",
          filterable: true,
          value: "businessName",
          width: "500px",
        },
        // { text: "Nombre comercial", value: "tradename", width: "200px" },
        { text: "NIF", value: "nif" },
        // { text: "Tipo de Cliente", value: "customerType", width: "150px" },
        // { text: "Promotor", value: "promoter", width: "200px" },
        // { text: "Email", value: "email" },
        // { text: "Persona de contacto", value: "contactPerson", width: "200px" },
        { text: "Detalle", value: "actions", align: "center", width: "90px" },
      ],
      headersSuppliers: [
        {
          text: "Denominación jurídica",
          align: "start",
          filterable: true,
          value: "businessName",
          width: "500px",
        },
        // { text: "Nombre comercial", value: "tradename", width: "200px" },
        { text: "NIF", value: "nif" },
        // { text: "Tipo de Cliente", value: "customerType", width: "150px" },
        // { text: "Promotor", value: "promoter", width: "200px" },
        // { text: "Email", value: "email" },
        // { text: "Persona de contacto", value: "contactPerson", width: "200px" },
        // { text: "Doc.NIF", value: "justification.nifCardInfo" },
        // { text: "DIAN", value: "justification.tributaryCertificateInfo" },
        // { text: "Certificado SS ", value: "justification.ssCertificateInfo" },
        // { text: "Compliance", value: "justification.copyCertificateMSInfo" },
        // { text: "Aviso Embargo.", value: "embargo" },
        { text: "Calificación", value: "qualification.qualification" },
        { text: "Detalle", value: "actions", align: "center" },
      ],
      suppliers: [],
      clients: [],
    };
  },
  computed: {
    ...mapGetters(["getClientsAndSuppliers", "getVaildSuppliers"]),
    getRoute() {
      return this.items[Number(this.types) - 1];
    },
  },
  watch: {
    getClientsAndSuppliers() {
      this.clients = [];
      this.suppliers = [];
      this.getClientsAndSuppliers.forEach((item) => {
        if (item.type === "cliente") {
          this.clients.push(item);
        } else {
          this.suppliers.push(item);
        }
      });
      //this.suppliers = this.getVaildSuppliers;
    },
    types() {
      this.typeSelection = Number(this.types);
    },
  },
  methods: {
    ...mapActions(["getDBClientsAndSuppliers"]),
    /**
     * type Supplier of Client
     */
    buildTypeOfClient(type) {
      return this[type].map((item) => {
        if (item.customerType === "pj") {
          return { ...item, customerType: "Persona Jurídica" };
        } else {
          return { ...item, customerType: "Persona Física" };
        }
      });
    },
  },
  created() {
    this.getDBClientsAndSuppliers();
    this.typeSelection = Number(this.types);
  },
};
</script>

<style scoped>
.breadcrumbs__wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.breadcrumbs__title {
  padding: 8px 0;
  border-bottom: 3px solid #008076;
}

.theme--light.v-btn.v-btn--has-bg {
  background: #008076;
}

.menu__dropdown {
  cursor: pointer;
}

.btn__not__selected {
  background: #969696 !important;
}
</style>
